import { render, staticRenderFns } from "./BlockDetail.vue?vue&type=template&id=32315d7a&"
import script from "./BlockDetail.vue?vue&type=script&lang=js&"
export * from "./BlockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports